import { Component } from "@angular/core";
import { AbstractModal } from "src/app/shared/components/modal/abstractModal";

@Component({
    selector: "oe-controller-ess-tou-history",
    templateUrl: "./new-navigation.html",
    standalone: false,
})
export class ControllerEssTimeOfUseTariffHistoryComponent extends AbstractModal { }
